import Helper from '@ember/component/helper';
import { service } from '@ember/service';
export default class isLive extends Helper {
  @service clock;

  compute([startsAt, endsAt]) {
    return this.clock.date >= startsAt && this.clock.date <= endsAt;
  }
}
